// extracted by mini-css-extract-plugin
export var conversationListItem = "_x7-2";
export var fullBleedList = "_x7-3";
export var messageText = "_x7-1";
export var previewText = "_x7-0";